export const modalIds =  {
  confirmDeleteEmployee : 'confirmDeleteEmployee',
  confirmRetireEmployee : 'confirmRetireEmployee',
  confirmRecoverEmployee : 'confirmRecoverEmployee',
  confirmLabo : 'confirmLabo',
}
export const modalTypes =  {
  confirmModal: 'confirmModal',
  selectModal: 'selectModal',
}